import { render, staticRenderFns } from "./proServiceAdd.vue?vue&type=template&id=b867b8a2"
import script from "./proServiceAdd.vue?vue&type=script&lang=js"
export * from "./proServiceAdd.vue?vue&type=script&lang=js"
import style0 from "./proServiceAdd.vue?vue&type=style&index=0&id=b867b8a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports